var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Topbar"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('span', {
    staticClass: "logo"
  }, [_vm._v("在线简历")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [(_vm.logined) ? _c('div', {
    staticClass: "userAction"
  }, [_c('span', {
    staticClass: "welcome"
  }, [_vm._v("你好，" + _vm._s(_vm.user.username))]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("登出")])]) : _c('div', {
    staticClass: "userAction"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signUpDialogVisible = true
      }
    }
  }, [_vm._v("注册")]), _vm._v(" "), _c('MyDialog', {
    attrs: {
      "title": "注册",
      "visible": _vm.signUpDialogVisible
    },
    on: {
      "close": function($event) {
        _vm.signUpDialogVisible = false
      }
    }
  }, [_c('SignUpForm', {
    on: {
      "success": function($event) {
        _vm.signIn($event)
      }
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "button primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signInDialogVisible = true
      }
    }
  }, [_vm._v("登陆")]), _vm._v(" "), _c('MyDialog', {
    attrs: {
      "title": "登陆",
      "visible": _vm.signInDialogVisible
    },
    on: {
      "close": function($event) {
        _vm.signInDialogVisible = false
      }
    }
  }, [_c('SignInForm', {
    on: {
      "success": function($event) {
        _vm.signIn($event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('button', {
    staticClass: "primary",
    on: {
      "click": _vm.aloneView
    }
  }, [_vm._v("预览")]), _vm._v(" "), _c('button', {
    staticClass: "primary",
    on: {
      "click": _vm.quitAloneView
    }
  }, [_vm._v("退出")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-796ea49d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Topbar.vue
// module id = mZOR
// module chunks = 1